import React, { useEffect, useState } from 'react';

interface AriaLiveAnnouncerProps {
    message: string;
    role?: string;
    politeness?: 'polite' | 'assertive' | 'off';
    clearAfter?: number;
    ariaAtomic?: boolean;
    setAlert?: (message: string) => void;
}

const AriaLiveAnnouncer = ({
    message,
    role = 'status',
    politeness = 'polite',
    clearAfter = 1000,
    ariaAtomic = true,
    setAlert = () => {},
}: AriaLiveAnnouncerProps) => {
    const [announcement, setAnnouncement] = useState('');

    useEffect(() => {
        if (!message) return;

        setAnnouncement(message);

        const timer = setTimeout(() => {
            setAnnouncement('');
            setAlert?.('');
        }, clearAfter);

        return () => clearTimeout(timer);
    }, [message, clearAfter]);
    return (
        <div
            role={role}
            aria-live={politeness}
            aria-atomic={ariaAtomic}
            className="u-els-hide-visually"
        >
            {announcement}
        </div>
    );
};

AriaLiveAnnouncer.defaultProps = {
    role: 'status',
    politeness: 'polite' as const,
    clearAfter: 1000,
    ariaAtomic: true,
    setAlert: () => {},
};

export default AriaLiveAnnouncer;
